import { COOKIE, SID_UTILS } from '@iva/utils';
import { SID_COOKIES_PROP } from './config';
import { bannedBrowser } from './modules/browser';
import { STATES, syncidsDebug as debug } from './modules/debug';
/**
 * Transfer `sid`
 * Сreates sid cookie (if cookie does not exist) and passes sid to identity-storage
 * @param sid - sid value
 */
export const sidProcessing = (sid) => {
    var _a;
    debug('sid: Start of id processing.');
    if (bannedBrowser()) {
        // do not run on Safari or Firefox
        return;
    }
    if (!SID_UTILS.isValidSid(sid)) {
        debug(`sid: value "${sid}" is not valid.`);
        return;
    }
    const existingCookie = COOKIE.getCookie(SID_COOKIES_PROP.name);
    if (existingCookie && SID_UTILS.isValidSid(existingCookie)) {
        debug(`sid: cookie already exists.`);
        return;
    }
    const cookie = Object.assign(Object.assign({}, SID_COOKIES_PROP), { value: sid });
    try {
        COOKIE.setCookie(cookie.name, cookie.value, cookie.options);
        if (COOKIE.getCookie(cookie.name)) {
            debug('sid: cookie successfully created.');
            if ((_a = window.sznIVA) === null || _a === void 0 ? void 0 : _a.IS) {
                window.sznIVA.IS.updateIdentities({ sid });
                debug(`sid: value "${sid}" was passed to identity-storage.`);
            }
        }
        else {
            debug({ message: 'sid: cookie was not created.', state: STATES.ERROR });
        }
    }
    catch (error) {
        debug({ message: `sid: cookie was not created. Exception: "${error}".`, state: STATES.ERROR });
    }
};
/**
 * Transfer `said`
 * Passes said value to identity-storage
 * @param said - sid value
 */
export const saidProcessing = (said) => {
    var _a;
    debug('said: Start of id processing.');
    if (((_a = window.sznIVA) === null || _a === void 0 ? void 0 : _a.IS) && said) {
        const existingSaid = window.sznIVA.IS.getIdentity('login.said');
        if (existingSaid) {
            debug(`said: value "${existingSaid}" already exists in the identity-storage.`);
            return;
        }
        window.sznIVA.IS.updateIdentities({ said });
        debug(`said: value was passed to identity-storage.`);
    }
};
